<template>
	<div class="watch-dashboard-widget geo-fencing-widget">
		<div class="watch-dashboard-widget-header">
			<router-link :to="{ name: 'WatchGeofencing', params: { user_uid: user_uid, watch_id: watch_id } }" class="header-link">
				<h1>{{ $t('base.watch.geofencing') }}</h1>
				<h2 v-if="address"><span>{{ $t('base.watch.current_location') }}</span><span class="address">{{ address }}</span></h2>
			</router-link>
		</div>
		<div class="watch-dashboard-widget-body">
			<spinner v-if="loading"/>
			<error-box v-else-if="position.error" :error="position.error"/>
			<google-map v-else-if="position.data"
				:reading="reading"
				:zones="zones.data"
				:mapOptions="mapOptions"/>
			<p v-else>{{ $t('readings.general.no_location') }}</p>
		</div>
	</div>
</template>

<script>
import GoogleMapsLoader from 'google-maps'
import GoogleMap from '@/components/maps/GoogleMap'
import Readings from '@/utils/readings'
export default {
	components: {
		GoogleMap
	},
	props: [
		'user_uid',
		'watch_id',
		'position'
	],
	data () {
		return {
			name: 'watch dashboard geofencing',
			zones: {
				loading: false,
				error: null,
				data: []
			},
			address: null,
			mapOptions: {
				zoom: 16,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				zoomControl: false,
				draggable: false
			}
		}
	},
	computed: {
		loading () {
			return this.position.loading || this.zones.loading
		},
		reading () {
			return {
				date: this.position.data.datetime,
				position: [ this.position.data.values.latitude, this.position.data.values.longitude ]
			}
		}
	},
	watch: {
		'$route' () {
			this.address = null
		},
		position: {
			handler () {
				this.address = null
				if (this.position.data && this.position.data.values.latitude && this.position.data.values.longitude) {
					var geocoder = new google.maps.Geocoder
					var location = {
						lat: this.position.data.values.latitude,
						lng: this.position.data.values.longitude
					}
					geocoder.geocode({ 'location': location }, (results, status) => {
						if (status === 'OK') {
							if (results[0]) {
								results[0].address_components.forEach(element => {
									if (element.types.includes("route")) {
										this.address = element.short_name
									}
								})
							} else {
								this.$log.warn(this.name, 'google geocoder found no results')()
							}
						} else {
							this.$log.error(this.name, 'google geocoder failed due to: ' + status)()
						}
					})
				}
			},
			deep: true
		}
	},
	methods: {
		getZones () {
			this.zones.loading = true
			this.zones.data = []
			this.$api.geofencing.getAll(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info(this.name, 'geofencing.getAll OK', response)()
					this.zones.data = Readings.processZones(response.body)
				}).catch(error => {
					this.$log.error(this.name, 'geofencing.getAll ERROR', error)()
					this.zones.error = error
				}).finally(() => {
					this.zones.loading = false
				})
		}
	},
	mounted () {
		GoogleMapsLoader.KEY = this.$root.settings.googleMapsKey
		GoogleMapsLoader.LIBRARIES = this.$root.settings.googleMapsLibraries
		GoogleMapsLoader.load(() => {
			this.getZones()
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/widgets/GeoFencingWidget.vue